"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRowBeHighlighted = void 0;
const date_fns_1 = require("date-fns");
const shouldRowBeHighlighted = ({ id, lastCommentAt }, previousValue) => {
    if (id !== previousValue.id) {
        return false;
    }
    return (0, date_fns_1.isAfter)(new Date(lastCommentAt), new Date(previousValue.lastCommentAt));
};
exports.shouldRowBeHighlighted = shouldRowBeHighlighted;
